<template>
  <div class="common-map-components-search-wrap">
    <el-autocomplete
      clearable
      popper-class="map-search-input"
      v-model="mapLocalSearchText"
      :fetch-suggestions="handleMapLocalSearch"
      placeholder="请输入地名进行搜索"
      @select="handleMapLocalSearchItemSelect"
    >
      <div slot-scope="{ item }" :title="item.title + '\n' + item.address">
        <p class="suggest-tpl-name">{{ item.title }}</p>
        <span class="suggest-tpl-address">{{ item.address }}</span>
      </div>
    </el-autocomplete>
  </div>
</template>

<script>
export default JBoot({
  name: "commonMapSearch",

  registryName: "common-map-search",

  props: {},

  inject: {
    commonMapInstance: {
      type: Object,
      default() {
        return {};
      }
    }
  },

  data() {
    return {
      mapLocalSearchText: undefined
    };
  },

  computed: {},

  mounted() {
    this.$busListener("map.bd.ready", ({ instance, BMap }) => {
      this.mapInstance = instance;
      this.BMap = BMap;

      this.mapLocalSearchInstance = new this.BMap.LocalSearch(
        this.mapInstance,
        {
          onSearchComplete: results => {
            this.handleMapLocalSearchComplete &&
              this.handleMapLocalSearchComplete(results);
          }
        }
      );
    });
  },

  methods: {
    handleMapLocalSearch(text, cb) {
      if (!text) {
        return cb([]);
      }

      this.mapLocalSearchInstance.search(text);

      this.handleMapLocalSearchComplete = function(results) {
        let result = [];

        for (let i = 0; i < results.getCurrentNumPois(); i++) {
          result.push(results.getPoi(i));
        }

        cb(result);
      }.bind(this);
    },

    handleMapLocalSearchItemSelect(item) {
      this.mapLocalSearchText = item.title;

      this.mapInstance.setCenter(item.point);

      let marker = new this.BMap.Marker(item.point);

      this.mapInstance.addOverlay(marker);
    }
  },

  watch: {}
}).build();
</script>

<style lang="scss">
.common-map-components-search-wrap {
  & input {
    width: 200px;
    height: 30px;
    line-height: 30px;
    background-color: transparent;
    color: #333333 !important;
  }
  input::-webkit-input-placeholder {
    /* WebKit browsers 适配谷歌 */
    color: #333333;
  }
  input:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 适配火狐 */
    color: red;
  }
  input::-moz-placeholder {
    /* Mozilla Firefox 19+ 适配火狐 */
     color: red;
  }
  input:-ms-input-placeholder {
    /* Internet Explorer 10+  适配ie*/
    color: red;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/map/Search.vue